import { CellPlugin } from '@react-page/editor';
import ThreeRiversSearchResults, {
    BILL_NUMBER_LABEL, NAME_LABEL, DUE_DATE_LABEL, AMOUNT_DUE_LABEL, PAYMENT_OPTIONS_LABEL,
    MINIMUM_PARTIAL_PAYMENT_AMOUNT, MINIMUM_PAYMENT_TEXT, MINIMUM_PAYMENT_ERROR_TEXT, ALLOW_OVERPAYMENT, HEADER_BACKGROUND_COLOR, HEADER_PADDING, MARGIN, PADDING,
    OVERLAY_TEXT, OVERLAY_BACKGROUND, OVERLAY_TEXT_COLOR, OVERLAY_ICON_COLOR,
    NO_MATCH_FOUND_TEXT
} from './components/ThreeRiversSearchResults';

type Data = {
    title: string,
    billNumber: string,
    name: string,
    dueDate: string,
    amountDue: string,
    paymentOptions: string,
    minimumPartialPaymentAmount: number,
    minimumPaymentText: string,
    minimumPaymentErrorText: string,
    allowOverpayment: boolean,
    overlayText: string,
    overlayBackground: string,
    overlayTextColor: string,
    overlayIconColor: string,
    noMatchFoundText: string,
    headerBackgroundColor: string,
    headerPadding: string,
    margin: string,
    padding: string,
}

const ThreeRiversSearchResultsPlugin: CellPlugin<Data> = {
    Renderer: ({ data }) => (
        <ThreeRiversSearchResults
            billNumberLabel={data.billNumber}
            nameLabel={data.name}
            dueDateLabel={data.dueDate}
            amountDueLabel={data.amountDue}
            paymentOptionsLabel={data.paymentOptions}
            minimumPartialPaymentAmount={data.minimumPartialPaymentAmount}
            minimumPaymentText={data.minimumPaymentText}
            minimumPaymentErrorText={data.minimumPaymentErrorText}
            allowOverpayment={data.allowOverpayment}
            overlayText={data.overlayText}
            overlayBackground={data.overlayBackground}
            overlayTextColor={data.overlayTextColor}
            overlayIconColor={data.overlayIconColor}
            noMatchFoundText={data.noMatchFoundText}
            margin={data.margin}
            padding={data.padding}
            headerBackgroundColor={data.headerBackgroundColor}
            headerPadding={data.headerPadding}
        />
    ),
    id: 'threeRiversResultsPlugin',
    title: 'Three Rivers Search Results',
    description: 'Three Rivers Planning & Development District bill search results',
    version: 1,
    controls: [
        {
            title: 'Labels',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        billNumber: {
                            type: 'string',
                            default: BILL_NUMBER_LABEL,
                        },
                        name: {
                            type: 'string',
                            default: NAME_LABEL,
                        },
                        dueDate: {
                            type: 'string',
                            default: DUE_DATE_LABEL,
                        },
                        amountDue: {
                            type: 'string',
                            default: AMOUNT_DUE_LABEL,
                        },
                        paymentOptions: {
                            type: 'string',
                            default: PAYMENT_OPTIONS_LABEL,
                        },
                        noMatchFoundText: {
                            type: 'string',
                            default: NO_MATCH_FOUND_TEXT,
                        },
                        overlayText: {
                            type: 'string',
                            default: OVERLAY_TEXT
                        },
                        overlayBackground: {
                            type: 'string',
                            default: OVERLAY_BACKGROUND
                        },
                        overlayTextColor: {
                            type: 'string',
                            default: OVERLAY_TEXT_COLOR
                        },
                        overlayIconColor: {
                            type: 'string',
                            default: OVERLAY_ICON_COLOR
                        }
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Payment Rules',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        minimumPartialPaymentAmount: {
                            type: 'number',
                            title: 'Minimum partial payment amount ($)',
                            default: MINIMUM_PARTIAL_PAYMENT_AMOUNT
                        },
                        minimumPaymentText: {
                            type: 'string',
                            title: 'Minimum payment text ({amount} = minimum)',
                            default: MINIMUM_PAYMENT_TEXT
                        },
                        minimumPaymentErrorText: {
                            type: 'string',
                            title: 'Minimum payment error text ({amount} = minimum)',
                            default: MINIMUM_PAYMENT_ERROR_TEXT
                        },
                        allowOverpayment: {
                            type: 'boolean',
                            title: 'Allow payments greater than amount due',
                            default: ALLOW_OVERPAYMENT
                        },
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Styles',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        margin: {
                            type: 'string',
                            default: MARGIN,
                        },
                        padding: {
                            type: 'string',
                            default: PADDING,
                        },
                        headerBackgroundColor: {
                            type: 'string',
                            default: HEADER_BACKGROUND_COLOR,
                        },
                        headerPadding: {
                            type: 'string',
                            default: HEADER_PADDING,
                        }
                    },
                    required: [],
                },
            },
        },
    ],
};

export default ThreeRiversSearchResultsPlugin;
